// extracted by mini-css-extract-plugin
module.exports = {"container":"ExerciseSelect_container__1XjVE","header":"ExerciseSelect_header__1ThsE","content":"ExerciseSelect_content__3kLoi","icon":"ExerciseSelect_icon__1-3DU"};